import axios from 'axios';

export default async ({ id, versionId }) => {
  if (!id) return { data: [] };

  const { data } = await axios.get(`/api/learner/videos/playlist?topic_id=${id}${versionId ? `&version_id=${versionId}` : ''}`);

  return data;
};
